module.exports = __webpack_public_path__ + "img/adlist.3b09be7b.png";